import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISetUnavailableSlotsByTokenPayload {
    token?: string
    data: {
        timeslots: {
            startDate: string
            endDate: string
        }[]
    }
    sagaCB?: any
}

export interface ISetUnavailableSlotsByTokenState {
    status: string
    data: any
    errors: any
}

const initialState: ISetUnavailableSlotsByTokenState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const setUnavailableSlotsByToken = createSlice({
    name: 'sharedList/set-unavailable-slots-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISetUnavailableSlotsByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const setUnavailableSlotsByTokenActions = setUnavailableSlotsByToken.actions
export default setUnavailableSlotsByToken.reducer
